import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from '@mui/material';
import { ModuleConfig } from '@schamburg-web/interfaces';
import React from 'react';

interface DisplayCardProps {
  icon: any;
  module: ModuleConfig;
  children?: React.ReactNode;
}

const DisplayCard: React.FC<DisplayCardProps> = ({
  icon,
  module,
  children,
}) => {
  return (
    <Card className="card-body">
      {children ? (
        children
      ) : (
        <>
          <CardHeader
            avatar={<Avatar src={`/mapicons/${icon.icon}`} alt="Icon"></Avatar>}
            title={`${module.displayConfig?.label ?? ''} ${icon.id}`}
          ></CardHeader>
          <CardContent>
            <Typography variant="h5" component="div"></Typography>
            <Typography variant="body2" color="text.secondary"></Typography>
          </CardContent>
        </>
      )}
    </Card>
  );
};

export default DisplayCard;
